import { Col, Row } from 'antd';
import React from 'react';
import { useState } from 'react';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomInput from '../../../../../v2-components/Antd/Input';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import { checkReverse } from './handle/check-reverse.handle';
import { generateOptions } from './handle/generate-options.handle';

export default function EditQuantityModal(props) {
	const [products, setProducts] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	const handleCloseModal = () => {
		setProducts([]);
		props.setOpenEditQuantity(false);
	};

	const handleOpenConfirmModal = () => {
		console.log('products', products);
		setOpenConfirmModal(true);
	};

	const handleConfirmQuantity = async () => {
		setOpenConfirmModal(false);
		await props.handleChangeQuantity(products);
	};

	const onChangeTotal = (newQuantity, p) => {
		const existingProductIndex = products.findIndex((product) => product.code_internal === p.code_internal);
		if (existingProductIndex !== -1) {
			const updatedProducts = products.map((product, index) => {
				if (index === existingProductIndex) {
					return { ...product, quantity: p.quantity - newQuantity };
				}
				return product;
			});
			setProducts(updatedProducts);
		} else {
			setProducts([...products, { code_internal: p.code_internal, quantity: p.quantity - newQuantity }]);
		}
	};

	return (
		<CustomModal onCancel={handleCloseModal} footer={null} open={props.openEditQuantity} destroyOnClose={true} centered>
			<h2>Ajuste de stock</h2>
			<CustomDivider />
			<h3>Stock</h3>

			<Row>
				{props.products.map((product, index) => (
					<React.Fragment key={index}>
						<Col span={8}>
							<h3>Producto</h3>
							<p>{product.name}</p>
						</Col>
						<Col span={8}>
							<h3>Cantidad actual</h3>
							<CustomInput
								style={{ width: '70%' }}
								value={`${checkReverse(product)}`}
								placeholder="Precio Actual"
								type="text"
								className="default"
								disabled={true}
							/>
						</Col>
						<Col span={8}>
							<h3>Cantidad nueva</h3>
							<CustomSelect
								style={{ width: '70%' }}
								onChange={(e) => onChangeTotal(e, product)}
								placeholder="Seleccionar"
								type="number"
								className="default"
								options={generateOptions(checkReverse(product))}
							/>
						</Col>
					</React.Fragment>
				))}
			</Row>
			<CustomDivider />
			<div className="button-container">
				<CustomButton onClick={handleCloseModal}>Cancelar</CustomButton>
				<CustomButton onClick={handleOpenConfirmModal} disabled={products.length < 1}>
					Continuar
				</CustomButton>
			</div>
			<CustomModal onCancel={() => setOpenConfirmModal(false)} open={openConfirmModal} footer={null} centered>
				<h4>Confirmar devolución</h4>
				<CustomDivider />
				<p>Al hacer cambios en el stock de productos se realizará la reversa de dinero al cliente.</p>
				<p style={{ marginBottom: '40px' }}>
					<strong>Puedes realizar una sola reversa por orden.</strong>
				</p>

				<CustomButton style={{ marginRight: '15px' }} onClick={() => setOpenConfirmModal(false)}>
					Cancelar
				</CustomButton>
				<CustomButton onClick={handleConfirmQuantity}>Confirmar</CustomButton>
			</CustomModal>
		</CustomModal>
	);
}
